import { render, staticRenderFns } from "./vResetPassword.vue?vue&type=template&id=2fd55be6&"
import script from "./vResetPassword.vue?vue&type=script&lang=js&"
export * from "./vResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./vResetPassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports